import dayjs from 'dayjs';
import { THAI_MONTHS, THAI_MONTHS_SHORT } from './constants';

// วันที่กำหนดของ template — รายเดือนโชว์แค่วัน, รายปีโชว์วัน+เดือน (ปีไม่มีความหมาย ไม่ต้องโชว์)
export function formatRecurDate(recurType, date) {
  if (!date) return '-';
  const d = dayjs(date);
  return recurType === 'monthly' ? `ทุกวันที่ ${d.format('D')}` : `ทุกวันที่ ${d.format('D MMM')}`;
}

// "YYYY-MM"/"YYYY" -> ป้ายอ่านง่าย เช่น "ม.ค. 2026" หรือ "2026"
function formatPeriodKeyLabel(key, recurType) {
  if (!key) return null;
  if (recurType === 'monthly') {
    const [y, m] = key.split('-');
    return `${THAI_MONTHS[Number(m) - 1]?.slice(0, 3) || m} ${y}`;
  }
  return key;
}

// ช่วงเวลาที่ให้เตือน — ไม่ได้ตั้งไว้เลย = "ไม่จำกัด" (ไม่มีวันหมดอายุ)
export function formatRangeLabel(recurType, rangeStart, rangeEnd) {
  if (!rangeStart && !rangeEnd) return 'ไม่จำกัดช่วงเวลา';
  const startLabel = formatPeriodKeyLabel(rangeStart, recurType) || 'เริ่มได้ทันที';
  const endLabel = formatPeriodKeyLabel(rangeEnd, recurType) || 'ไม่มีวันสิ้นสุด';
  return `${startLabel} — ${endLabel}`;
}

// ป้ายงวดแบบที่ใช้ในเอกสาร เช่น "ก.ย.69" (รายเดือน) / "ปี 69" (รายปี)
export function formatPeriodLabel(recurType, key) {
  if (!key) return '-';
  if (recurType === 'monthly') {
    const [y, m] = key.split('-');
    return `${THAI_MONTHS_SHORT[Number(m) - 1] || m}${String(Number(y) + 543).slice(-2)}`;
  }
  return `ปี ${String(Number(key) + 543).slice(-2)}`;
}

// 8618 -> "8,618", 8618.5 -> "8,618.50"
export function formatAmountVar(amount) {
  const n = Number(amount) || 0;
  const hasFraction = Math.round(n * 100) % 100 !== 0;
  return n.toLocaleString('en-US', {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

// แทนตัวแปรในชื่อรายการด้วยค่าของงวด (อิงวันที่รับเงินของงวด ไม่ใช่วันที่กดสร้าง — สร้างของ ก.ย. ช้าไป
// ต้น ต.ค. ก็ยังได้ "กันยายน") — ไม่ส่ง amount มา = คง {ยอด} ไว้ก่อน (แทนตอนกดบันทึก หลังกรอกยอดแล้ว)
export function applyNameVars(text, dueDate, amount) {
  if (!text) return '';
  const d = dayjs(dueDate);
  const beYear = d.year() + 543;
  const vars = [
    ['{เดือน}', THAI_MONTHS[d.month()]],
    ['{ด}', THAI_MONTHS_SHORT[d.month()]],
    ['{ปีเต็ม}', String(beYear)],
    ['{ปี}', String(beYear).slice(-2)],
  ];
  if (amount !== undefined && amount !== null && amount !== '') {
    vars.push(['{ยอด}', formatAmountVar(amount)]);
  }
  return vars.reduce((acc, [token, value]) => acc.split(token).join(value), text);
}

// ช่อง "รายการ" ตอนสร้างรายการเบิก: เก็บข้อความเป็นท่อนๆ ที่คั่นด้วยตำแหน่งของ {ยอด} (segments) แล้วโชว์เป็น
// segments.join(amountText) — ยอดเปลี่ยนเมื่อไหร่ตัวเลขในช่องเปลี่ยนตามทันที ฟังก์ชันนี้แปลงการพิมพ์แก้ในช่อง
// (ข้อความที่โชว์ก่อน → หลัง) กลับเป็น segments ใหม่: แก้ในท่อนข้อความ = แก้ท่อนนั้น (ยอดยังผูกอยู่),
// แก้ทับตัวเลขยอด = ถือว่าตั้งใจพิมพ์เอง เลิกผูกยอดทั้งหมด (กลายเป็นข้อความธรรมดาท่อนเดียว)
export function editNameSegments(segments, amountText, newValue) {
  const oldValue = segments.join(amountText);
  const maxCommon = Math.min(oldValue.length, newValue.length);
  let prefix = 0;
  while (prefix < maxCommon && oldValue[prefix] === newValue[prefix]) prefix += 1;
  let suffix = 0;
  while (
    suffix < maxCommon - prefix &&
    oldValue[oldValue.length - 1 - suffix] === newValue[newValue.length - 1 - suffix]
  ) suffix += 1;
  const oldEnd = oldValue.length - suffix;
  const inserted = newValue.slice(prefix, newValue.length - suffix);

  let start = 0;
  for (let i = 0; i < segments.length; i += 1) {
    const end = start + segments[i].length;
    if (prefix >= start && oldEnd <= end) {
      const next = [...segments];
      next[i] = segments[i].slice(0, prefix - start) + inserted + segments[i].slice(oldEnd - start);
      return next;
    }
    start = end + amountText.length;
  }
  return [newValue];
}
